import { createContext, useContext } from 'react';
import { IContributorTemplate, IDataRequest, IDuaDetails, IDuaDocuments } from '@vivli/features/data-requests/infrastructure/interface';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { IVirtualMachine } from '@vivli/features/virtual-machine/infrastructure/interface';
import { UseFormReturn } from 'react-hook-form';
import { IStatusUpdate } from '@vivli/shared/infrastructure/interface';

interface IDataRequestContext {
    dataRequest: IDataRequest;
    updateDataRequest: (dataRequest: IDataRequest) => void;
    showApprovalButtons: boolean;
    setShowApprovalButtons: (show: boolean) => void;
    organizations: IOrganization[];
    virtualMachine: IVirtualMachine;
    showResearchResults: boolean;
    isUpdatingStatus: boolean;
    setIsUpdatingStatus: (isUpdating: boolean) => void;
    handleEditTitleClick: () => void;
    isSavingDataRequest: boolean;
    isSubmittingDataRequest: boolean;
    handleFormSave: (submitRequest: boolean) => void;
    handleFormSavePublish: (submitRequest: boolean) => Promise<IDataRequest>;
    handleDataPackageCreation: () => void;
    getResetToDraftVisibility: () => boolean;
    updateIsSaving: (status: boolean) => void;
    isAdminEditing: boolean;
    setIsAdminEditing: (isEditing: boolean) => void;
    ownsDataRequest: () => boolean;
    handelDuaSave: (tableData: IContributorTemplate) => void;
    handlePublishingSaveWithSecondaryDoi: () => void;
    planningTableData: IContributorTemplate[];
    duaDetails: IDuaDetails;
    setDuaDetails: (duaDetails: IDuaDetails) => void;
    setPlanningTableData: (tableData: IContributorTemplate[]) => void;
    statusUpdateState: IStatusUpdate;
    setStatusUpdateState: (statusUpdate: IStatusUpdate) => void;
    duaDocuments: IDuaDocuments[];
    setDuaDocuments: (duaDocuments: IDuaDocuments[]) => void;
    includeRiskScore: boolean;
    setIncludeRiskScore: (show: boolean) => void;
    surveyHasErrors: boolean;
    setSurveyHasErrors: (hasErrors: boolean) => void;
    handleSavePdfVersion: () => void;
    dateEditingEnabled: boolean;
    isActiveUserOrgAdmin: () => boolean;
}

export const DataRequestContext = createContext<IDataRequestContext>(null);

export const useDataRequestContext = () => useContext(DataRequestContext);
